<template>
    <div class="color-input">
        <toolcool-color-picker
            :color="value"
            @change="$emit('input', $event.detail.hex)"
            button-padding="0px"
            button-width="20px"
            button-height="20px"
        >
        </toolcool-color-picker>
    </div>
</template>

<script>
import "toolcool-color-picker";

export default {
    props: {
        defaultValue: {
            type: String,
            default: '',
        },
    },
    watch: {
        defaultValue(){
            this.value = this.defaultValue;
            this.$emit('input', this.defaultValue);
        }
    },
    mounted() {
        this.value = this.defaultValue;
        this.$emit('input', this.defaultValue);
    },
    data() {
        return {
            value: null
        };
    }
};
</script>

<style lang="scss">
@import "../../style/common/ColorInput.scss";
</style>
